__turbopack_context__.v({
  "subtitle": "search-module-scss-module__sQEKmG__subtitle",
  "title": "search-module-scss-module__sQEKmG__title",
});
